/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RevokeMemberSignInsRequestBody,
  RevokeMemberSignInsRequestBody$Outbound,
  RevokeMemberSignInsRequestBody$outboundSchema,
} from "../components/revokemembersigninsrequestbody.js";

export type RevokeOrganizationMemberSignInsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RevokeOrganizationMemberSignInsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  revokeMemberSignInsRequestBody: RevokeMemberSignInsRequestBody;
};

/** @internal */
export type RevokeOrganizationMemberSignInsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeOrganizationMemberSignInsSecurity$outboundSchema:
  z.ZodMiniType<
    RevokeOrganizationMemberSignInsSecurity$Outbound,
    RevokeOrganizationMemberSignInsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function revokeOrganizationMemberSignInsSecurityToJSON(
  revokeOrganizationMemberSignInsSecurity:
    RevokeOrganizationMemberSignInsSecurity,
): string {
  return JSON.stringify(
    RevokeOrganizationMemberSignInsSecurity$outboundSchema.parse(
      revokeOrganizationMemberSignInsSecurity,
    ),
  );
}

/** @internal */
export type RevokeOrganizationMemberSignInsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RevokeMemberSignInsRequestBody: RevokeMemberSignInsRequestBody$Outbound;
};

/** @internal */
export const RevokeOrganizationMemberSignInsRequest$outboundSchema:
  z.ZodMiniType<
    RevokeOrganizationMemberSignInsRequest$Outbound,
    RevokeOrganizationMemberSignInsRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      revokeMemberSignInsRequestBody:
        RevokeMemberSignInsRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        revokeMemberSignInsRequestBody: "RevokeMemberSignInsRequestBody",
      });
    }),
  );

export function revokeOrganizationMemberSignInsRequestToJSON(
  revokeOrganizationMemberSignInsRequest:
    RevokeOrganizationMemberSignInsRequest,
): string {
  return JSON.stringify(
    RevokeOrganizationMemberSignInsRequest$outboundSchema.parse(
      revokeOrganizationMemberSignInsRequest,
    ),
  );
}
